export default "__VITE_ASSET__5576053e__"